import replace from "lodash.replace";
import { Nullable } from "../types";
import { spaceCharacter, timeSeparator, utcTimeOffset } from "../constants";

const formatBuName = (buName: string) => replace(buName, "_", "-");

const getMagentoUrlPath = (businessUnitGbsCode: string, eventGbsCode: string, category: string) => {
  return `${formatBuName(businessUnitGbsCode)}/${eventGbsCode}/${category}`;
};

const getMagentoStore = (defaultCurrencyCode: string, locale: string) => {
  const magentoLocale = replace(locale, "-", "_").toLowerCase();
  return `${defaultCurrencyCode.toLowerCase()}_${magentoLocale}`;
};

const parseMagentoToUTCDate = (date: Nullable<string> | undefined) => {
  if (!date) return;
  return date.replace(spaceCharacter, timeSeparator).concat(utcTimeOffset);
};

const magentoUtils = {
  getMagentoUrlPath,
  getMagentoStore,
  parseMagentoToUTCDate
};

export default magentoUtils;
